module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_SpatialResearch.7750d37d.png";